import merge from "deepmerge";
import Cookies from "js-cookie";
import { getBasket } from "./getBasket";
import { Variant, Product } from "../../types/types";
import { generatePageLoadAnalyticsDataLayer } from "./generatePageLoadAnalyticsDataLayer";
import { generatePromotionClassifications } from "./helpers";

const ANALYTICS_EVENT = "dataStateChange";

const dispatchEvent = (
  action: string,
  payload: any, // eslint-disable-line @typescript-eslint/no-explicit-any
  jlData?: {
    [key: string]: unknown;
  },
) => {
  updateBasketAnalyticsObject();

  if (jlData) setAnalyticsData(jlData);

  const AnlayticsDebugEnabled = Cookies.get("DEBUG_ANALYTICS");

  if (AnlayticsDebugEnabled) {
    /* eslint-disable no-console */
    console.log("Dispatch Analytics Event", ANALYTICS_EVENT, {
      action,
      ...payload,
    });
  }

  document.body.dispatchEvent(
    new CustomEvent(ANALYTICS_EVENT, {
      detail: {
        action,
        ...payload,
      },
    }),
  );
};

const setAnalyticsData = (payload = {}) => {
  const currentJLData = window.jlData || {};
  const mergePromotionClassificiations = (
    _currentPromotionClassifications: { group: string; type: string }[],
    newPromotionClassifications: { group: string; type: string }[],
  ) => newPromotionClassifications;

  const options = {
    customMerge: (key: string) => {
      if (key === "promotionClassifications") {
        return mergePromotionClassificiations;
      }
      return;
    },
  };

  const newJLData = merge(currentJLData, payload, options);
  window.jlData = newJLData;
};

const updateBasketAnalyticsObject = () => {
  const basket = getBasket();
  window.jlData = { ...window.jlData, basket };
};

export const dispatchAnalyticsEvent = (
  action: string,
  payload: any, // eslint-disable-line @typescript-eslint/no-explicit-any
  jlData: {
    [key: string]: unknown;
  },
) => {
  if (
    !(window && window.Bootstrapper && window.Bootstrapper.dataStateChangeReady)
  ) {
    document.body.addEventListener(
      "EnsightenReady",
      () => dispatchAnalyticsEvent(action, payload, jlData),
      { once: true },
    );
    return;
  }

  if (
    action !== "pageload" &&
    !(window && window.Bootstrapper && window.Bootstrapper.ensEventsReady)
  ) {
    document.body.addEventListener(
      "ensEventsReady",
      () => dispatchAnalyticsEvent(action, payload, jlData),
      { once: true },
    );
    return;
  }

  dispatchEvent(action, payload, jlData);
};

export const dispatchVariantChangedAnalyticsEvent = (
  type: string,
  selectedVariant: Variant,
  product: Product,
) => {
  dispatchAnalyticsEvent(
    "pdp.productSkuChanged",
    { type },
    {
      page: {
        productPages: {
          size: selectedVariant.differentiators?.size,
          colour: selectedVariant.differentiators?.colour,
          displayedSku: selectedVariant?.aliases?.skuId,
          emwbisForm: selectedVariant?.customerNotifiableEvents?.backInStock,
          price: selectedVariant?.price?.value,
          promotionClassifications: generatePromotionClassifications(
            product,
            selectedVariant,
          ),
        },
      },
    },
  );
};

export const dispatchPageLoadAnalyticsEvent = (
  product: Product,
  selectedVariant: Variant,
  pageConfigName?: string,
) => {
  dispatchAnalyticsEvent(
    "pageload",
    {},
    generatePageLoadAnalyticsDataLayer(
      product,
      selectedVariant,
      pageConfigName,
    ),
  );
};
